import { useQuery, useQueryClient } from '@tanstack/react-query';
import { ROUTES, type DocRecord } from '@serb/shared';
import { api, errorText } from '../../api/client';
import { KEYS } from '../../api/keys';
import { SAMPLE_DATA } from '../../lib/sample';
import { INITIAL_DOCS } from './sample';

/**
 * The document records, shared by every page that shows them. They are kept in the Serb Mind vault (Data/documents.csv),
 * written by Claude, so the app only shows them. With sample data on, made-up ones can be added and removed in the browser.
 */
export function useDocuments() {
  const qc = useQueryClient();
  const q = useQuery({
    queryKey: KEYS.documents,
    queryFn: SAMPLE_DATA ? async () => INITIAL_DOCS : () => api.get<DocRecord[]>(ROUTES.api.documents),
    staleTime: SAMPLE_DATA ? Infinity : 0,
    gcTime: SAMPLE_DATA ? Infinity : undefined,
    refetchOnWindowFocus: !SAMPLE_DATA,
  });
  const change = (fn: (all: DocRecord[]) => DocRecord[]) =>
    qc.setQueryData<DocRecord[]>(KEYS.documents, (all = []) => fn(all));
  return {
    items: q.data ?? [],
    loading: q.isPending,
    error: q.isError ? errorText(q.error, 'The documents could not be loaded.') : '',
    /** the records of one shipment */
    forShipment: (srb: string) => (q.data ?? []).filter((r) => r.srb === srb),
    /** records can be added and removed here only in the sample build; real ones are written to the vault by Claude */
    editable: SAMPLE_DATA,
    add: (r: DocRecord) => change((all) => [r, ...all]),
    /** removes the RECORD only; the file in Finder is never touched */
    remove: (id: string) => change((all) => all.filter((r) => r.id !== id)),
  };
}
